// extracted by mini-css-extract-plugin
export var cartContainer = "_om-4";
export var gray = "_om-1";
export var itemContainer = "_om-2";
export var itemDetails = "_om-3";
export var strong = "_om-0";